export default "__VITE_ASSET__92399eaf__"